import Blog from "@/Layouts/Blog";
import Contact from "@/Sections/Contact";
import { Head } from "@inertiajs/inertia-react";

export default () => {
    return (
        <Blog>
            <Head>
                <title>Detoxen: ja of nee?</title>
                <link rel="canonical" href={route("blogs.twelfth")} />

                <meta
                    name="viewport"
                    content="width=device-width, initial-scale=1"
                />
                <meta property="og:locale" content="nl_NL" />

                <meta
                    name="description"
                    content="Detoxen neemt de laatste enorm toe in populariteit. Het word om verschillende reden en op verschillende manieren gebruikt. De groente-en fruitsapjes vliegen je tegenwoordig om de oren. Maar is detoxen dan daadwerkelijk zo gezond en effectief?"
                />
                <meta
                    property="og:description"
                    content="Detoxen neemt de laatste enorm toe in populariteit. Het word om verschillende reden en op verschillende manieren gebruikt. De groente-en fruitsapjes vliegen je tegenwoordig om de oren. Maar is detoxen dan daadwerkelijk zo gezond en effectief?"
                />
                <meta property="og:url" content={route("blogs.twelfth")} />
                <meta property="og:type" content="article" />
                <meta
                    property="og:title"
                    content="Detoxen: ja of nee? - WE ARE Personal Training Uden en Schijndel"
                />
                <meta
                    property="og:image"
                    content="/assets/blog/stress-verminderen.jpg"
                />
            </Head>

            <div className="bg-black">
                <div className="relative xs:h-[30vh] sm:h-[30vh] md:h-[65vh] lg:h-[65vh]  pb-32">
                    <div>
                        <div className="absolute inset-0">
                            <picture>
                                <source
                                    srcSet="/assets/blog/webp/detoxen.webp"
                                    type="image/webp"
                                    alt="Detoxen"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                                <source
                                    srcSet="/assets/blog/detoxen.jpg"
                                    type="image/jpeg"
                                    alt="Detoxen"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                                <img
                                    src="/assets/blog/detoxen.jpg"
                                    alt="Detoxen"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                            </picture>
                            <div
                                className="absolute inset-0 bg-gray-800 opacity-50 mix-blend-multiply"
                                aria-hidden="true"
                            />
                        </div>
                    </div>
                </div>
                <div className="xs:px-8 sm:px-8 md:px-16 lg:px-16 xs:py-12 sm:py-12 md:py-24 lg:py-24 max-w-7xl mx-auto">
                    <h1 className="block text-white font-custom italic font-bold uppercase xl:inline xs:text-5xl sm:text-5xl md:text-6xl lg:text-6xl break-words">
                        Detoxen: ja of nee?
                    </h1>
                    <p className="mt-4 text-gray-100 break-words">
                        Detoxen neemt de laatste enorm toe in populariteit. Het
                        word om verschillende reden en op verschillende manieren
                        gebruikt. De groente-en fruitsapjes vliegen je
                        tegenwoordig om de oren. Maar is detoxen dan
                        daadwerkelijk zo gezond en effectief?
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Wat is detoxen?
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Detoxen is er in vele varianten, maar wij zullen uitgaan
                        van het detox-dieet. Hierbij word door middel van
                        groente-en fruitsapjes, voedingssupplementen,
                        darmspoelingen en volledig vasten het lichaam gereinigd
                        van afvalstoffen en gifstoffen. Dit gaat veelal gepaard
                        met het doel om ook nog gewicht te verliezen door deze
                        methode.
                    </p>

                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Waarom zou je detoxen?
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        De meest voorkomende redenen om te gaan detoxen zullen
                        afvallen en het reinigen van je lichaam na een periode
                        van ongezond leven zijn. Door het ongezonde
                        voedingspatroon zijn er veel afval-en gifstoffen
                        aanwezig in het lichaam. Door middel van een detox is
                        het lichaam dan weer ‘schoon’ en kun je weer gezond gaan
                        leven. Althans, dat is de gedachtegang hierachter.
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Is detoxen effectief?
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Op dit moment is er onvoldoende wetenschappelijk bewijs
                        dat detoxen effectief is. Er zijn wel onderzoeken te
                        vinden die beweren dat detoxen daadwerkelijk een
                        significant effect heeft, maar deze worden veelal als
                        onbetrouwbaar beschouwt. Daarnaast reinigt je eigen
                        lichaam zichzelf al. Afval- en gifstoffen worden
                        dagelijks afgebroken en afgevoerd via de nieren, lever
                        en darmen. Dit word uitgescheiden via bijvoorbeeld de
                        urine en zweet. Er is geen bewijs dat detoxen deze
                        processen verbeterd en/of versneld.
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Nadelen van detoxen
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Er zitten ook nadelen aan het gebruik van een detoxkuur.
                        Op korte termijn zijn er nauwelijks nadelige gevolgen
                        van een detoxkuur. Op de lange termijn zijn er wel
                        degelijk gezondheidsrisico’s.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Als je te lang gebruik maakt van een detoxkuur kun je
                        belangrijke voedingsstoffen missen in jouw eetpatroon.
                        Er ontbreken essentiële nutriënten zoals vezels,
                        vitamines en mineralen. Daarnaast levert een te groot
                        calorietekort die gepaard gaat met een detoxkuur stress
                        op voor het lichaam, wat nadelige gevolgen heeft op de
                        lange termijn.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Verder moet je oppassen bij het gebruik van bijvoorbeeld
                        geactiveerd kool, het eten van klei en kalk en het
                        gebruik maken van het spoelen van de mond met olie. Deze
                        worden aangeraden bij sommige detoxkuren, maar hebben
                        ieder nadelige gevolgen voor het lichaam.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Ook zul je bij het detoxen veel spiermassa kunnen
                        verliezen, omdat een dergelijk dieet te weinig eiwitten
                        bevat om de spieren te kunnen behouden. Hoe langer een
                        detoxkuur duurt, hoe harder je spiermassa zult gaan
                        verliezen. Zorg er dus voor dat je nooit langdurig
                        gebruik maakt van een detoxkuur.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Als laatste is het gewichtsverlies dat je hebt bij een
                        detoxkuur in de meeste gevallen van korte duur. Een
                        groot deel van het gewichtsverlies wat optreedt komt
                        door heel veel vochtverlies en minder inhoud in de maag
                        tijdens de kuur. Hierdoor zul je op hele korte termijn
                        heel veel kunnen afvallen, maar zodra je weer gaat eten
                        zoals voorheen zullen deze kilo’s er ook weer meteen
                        aankomen.
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Wat kan ik dan wel doen?
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Als je gezonder wilt gaan leven, moet je als eerste meer
                        gaan bewegen en/of een gezonder voedingspatroon gaan
                        creëren. Een gevarieerd eetpatroon zorgt ervoor dat je
                        niet teveel van een bepaalde afval-of gifstof
                        binnenkrijgt. Hierdoor zal het niet schadelijk zijn voor
                        je lichaam. Daarnaast zorgt het eten van voldoende
                        vezels bij het uitscheiden van gifstoffen.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Door een gezond voedingspatroon te creëren zul je een
                        duurzaam resultaat behalen. Hierbij blijven de kilo’s er
                        ook af, en zul je merken dat je steeds fitter word en
                        beter in je vel komt te zitten. Het is aantrekkelijk om
                        voor het snelle resultaat te gaan, maar op de lange
                        termijn geeft dit helaas vaak niet het gewenste
                        resultaat.
                    </p>
                </div>
                <Contact />
            </div>
        </Blog>
    );
};
